import { type FC, type PropsWithChildren, type ReactNode } from "react";
import styled from "styled-components";

import PageTitle from "./PageTitle";

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

interface Props {
    title: ReactNode;
    button?: ReactNode;
}

export const PageHeader: FC<PropsWithChildren<Props>> = ({ title, button }) => {
    return (
        <Wrapper>
            <PageTitle>{title}</PageTitle>
            {button && <div>{button}</div>}
        </Wrapper>
    );
};
